import { ICellRendererParams } from 'ag-grid-community';
import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Phases } from 'components/organisms/projects/project-list/columns/phases';
import { getTransformedPhases } from 'components/organisms/projects/project-list/helpers/get-phases-aggregate';

export const ProjectPhasesCellRenderer: FC<ICellRendererParams> = ({
  data,
}) => {
  const projectPhases = useMemo(() => {
    return getTransformedPhases(data.projectPhases ?? []);
  }, [data.projectPhases]);

  return (
    <Phases
      title={<FormattedMessage id="projects.list.phases" />}
      subTitle={data.projectName}
      phases={projectPhases}
    />
  );
};
